import { FC } from 'react';
import { NavLinkProps, Link as ReactRouterLink } from 'react-router-dom';
import { Link as MuiLink, LinkProps } from '@mui/material';

const Link: FC<Omit<LinkProps, 'component'> & NavLinkProps> = (props) => (
  <MuiLink component={ReactRouterLink} {...props} />
);

export default Link;
